import { useContent } from "../lib/content";

export default function Footer() {
  const { t, logo } = useContent();
  return (
    <footer data-testid="footer" className="border-t border-white/5 mt-32 py-16">
      <div className="max-w-7xl mx-auto px-6 text-center">
        {logo ? (
          <img src={logo} alt={t("brand_name")} className="h-14 w-14 mx-auto mb-4 object-contain" />
        ) : (
          <div className="h-14 w-14 mx-auto mb-4 rounded-full border border-[#C9A25E]/40 flex items-center justify-center text-[#C9A25E] text-2xl">
            ☾
          </div>
        )}
        <p className="font-display text-2xl text-white tracking-tight">{t("brand_name", "Etérea Enlace")}</p>
        <p className="text-xs text-zinc-500 mt-3 tracking-[0.25em] uppercase">
          {t("footer_tagline", "Astrología evolutiva, escrita a mano")}
        </p>
        <div className="mt-8 flex justify-center gap-6 text-xs text-zinc-500">
          <span>{t("footer_privacy", "Política de privacidad")}</span>
          <span>·</span>
          <span>{t("footer_terms", "Términos de servicio")}</span>
        </div>
        <p className="text-xs text-zinc-600 mt-6">
          © {new Date().getFullYear()} {t("brand_name", "Etérea Enlace")}. {t("footer_rights", "Todos los derechos reservados.")}
        </p>
      </div>
    </footer>
  );
}
